import React from 'react';

class SelectFreights extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    isAllChecked() {
        const { freights, selectedFreights } = this.props;
        return freights.every(freight => selectedFreights.indexOf(freight.id) > -1);
    }

    onChange(event, id) {        
        const { selectedFreights, onChange } = this.props;
        const isChecked = event.target.checked;
        const newSelectedFreights = [...selectedFreights];
        
        if (isChecked) {
            if (newSelectedFreights.indexOf(id) < 0) {
                newSelectedFreights.push(id);
            }
        } else {
            const index = newSelectedFreights.indexOf(id);
            if (index > -1) {
                newSelectedFreights.splice(index, 1);
            }
        }
        
        onChange(newSelectedFreights);   
    }

    onChangeAll() {
        const { freights, onChange } = this.props;

        return function (event) {
            const isChecked = event.target.checked;

            if (isChecked) {
                onChange(freights.map(freight => freight.id));
            } else {
                onChange([])
            }
        }
    }

	render() {
        const { freights, selectedFreights } = this.props;
        
        return (
            <div>
                <label className='labelactive'>Freights</label>
                <div className='list-item-checkbox' style={{ display: 'none' }}>
                    <input 
                        type='checkbox'
                        checked={this.isAllChecked()}
                        onChange={this.onChangeAll()} />
                    <label className='checkbox-label'>Select/Deselect All</label>
                </div>
                {freights.map(freight => 
                    <div key={freight.id} className='list-item-checkbox'>
                        <input
                            type='checkbox'
                            checked={selectedFreights.indexOf(freight.id) > -1}
                            onChange={(event) => this.onChange(event, freight.id)} />
                        <label className='checkbox-label'>{freight.title}</label>
                    </div>                      
                )}        
            </div>
        )
    }
}

export default SelectFreights;



// WEBPACK FOOTER //
// ./source/components/selectFreights.js